import { get_assistant_reply } from "./assistant_reply_rules";

export default {
  name: "BolideAssistant",

  props: {
    is_open: Boolean,
  },

  emits: ["close-assistant"],

  data() {
    return ({
      user_message: "",
      messages: [
        {
          sender: "assistant",
          text: "Hello! I'm VSI Assist. How can I help you today?",
        },
      ],
    });
  },

  watch: {
    messages() {
      this.$nextTick(() => {
        const el = this.$refs.chat_body;
        if (el) {
          el.scrollTop = el.scrollHeight;
        }
      });
    },

    is_open(isOpen) {
      document.body.classList.toggle("chatbot-lock", isOpen);
    },
  },

  mounted() {
    document.addEventListener("mousedown", this.handle_click_outside);
    document.addEventListener("touchstart", this.handle_click_outside);
  },

  beforeUnmount() {
    document.removeEventListener("mousedown", this.handle_click_outside);
    document.removeEventListener("touchstart", this.handle_click_outside);
    document.body.classList.remove("chatbot-lock");
  },

  methods: {
    close_assistant() {
      this.$emit("close-assistant");
    },

    handle_click_outside(event) {
      if (!this.is_open) return;

      const panel = this.$refs.chatbot;
      if (panel && !panel.contains(event.target)) {
        this.close_assistant();
      }
    },

    send_message() {
      if (!this.user_message.trim()) return;

      const text = this.user_message.trim();
      this.messages.push({ sender: "user", text });
      this.user_message = "";

      setTimeout(() => {
        this.generate_reply(text.toLowerCase());
      }, 350);
    },

    add_assistant_reply(text) {
      this.messages.push({ sender: "assistant", text });
    },

    generate_reply(query) {
      this.add_assistant_reply(get_assistant_reply(query));
    },
  },
};
